import React from 'react';
import { ChipField, List, TextField } from 'react-admin';

import StateFilters from './filter';
import EmptyPage from 'components/EmptyPage';
import DataGridList from 'components/containers/List';
import { Paginator } from 'components/Paginator/Paginator';
import ListActions from 'components/ListAction/ListActions';

export const StatesList = (props) => (
	<List
		filters={<StateFilters/>}
		pagination={<Paginator />}
		sort={{ field: 'id', order: 'DESC' }}
		perPage={15}
		{...props}
		empty={<EmptyPage create />}
		actions={<ListActions listExporterType='States' />}
	>
		<DataGridList show={false}>
			<ChipField source='iso' label='ISO' />
			<TextField source='name' label='Name' />
		</DataGridList>
	</List>
);